import type { IconData } from '@stacksjs/iconify-core'

export const noSmakingArea: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M36.136 30.906A156 156 0 0 1 36 24c0-2.963.062-5.242.136-6.906M3 3l42 42\"/><path d=\"M17.053 17.03C19.105 17.01 21.416 17 24 17c8.039 0 13.77.11 17.193.203C43.327 17.262 45 19.01 45 21.146v5.709c0 2.135-1.673 3.883-3.807 3.942c-2.331.063-5.733.134-10.205.174M24 31c-7.99 0-13.374-.108-16.524-.202c-2.153-.063-4.021-1.369-4.287-3.505A27 27 0 0 1 3 24c0-1.3.078-2.392.19-3.292c.265-2.137 2.133-3.442 4.286-3.506c.845-.025 1.85-.051 3.024-.076\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default noSmakingArea
